"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = exports.Content = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _toColorString = _interopRequireDefault(require("polished/lib/color/toColorString"));

var _rem = _interopRequireDefault(require("polished/lib/helpers/rem"));

var _designTokens = _interopRequireWildcard(require("@decisiv/design-tokens"));

var _commonUIColors = require("../../utils/commonUIColors");

var _color = _interopRequireDefault(require("../../modifiers/color"));

var _palette = require("../../modifiers/palette");

var _focusRingWithColor = _interopRequireDefault(require("../../utils/focusRingWithColor"));

var _styleModifiers = require("../../utils/styleModifiers");

var _Action = _interopRequireWildcard(require("./Action"));

var _constants = require("./constants");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    keys.push.apply(keys, Object.getOwnPropertySymbols(object));
  }

  if (enumerableOnly) keys = keys.filter(function (sym) {
    return Object.getOwnPropertyDescriptor(object, sym).enumerable;
  });
  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var _designTokens$color = _designTokens.default.color,
    interactionColors = _designTokens$color.interaction,
    statusColors = _designTokens$color.status;

var getContentMaxWidth = function getContentMaxWidth(props) {
  var isSingleChild = props.isSingleChild,
      hasIcon = props.hasIcon;
  var iconWidth = 12;
  var actionBorder = 1;
  var containerBorder = 2;
  var baseWidth = _constants.MAX_CONTAINER_WIDTH - _constants.CONTAINER_X_PADDING - containerBorder;
  var valuesToSubtract = [];
  !isSingleChild && valuesToSubtract.push(_constants.ACTION_WIDTH, actionBorder);
  hasIcon && valuesToSubtract.push(iconWidth, _constants.ICON_CONTENT_MARGIN);
  return (0, _rem.default)(valuesToSubtract.reduce(function (r, v) {
    return r - v;
  }, baseWidth));
};

var Content = _styledComponents.default.div.withConfig({
  displayName: "styles__Content",
  componentId: "sc-1sm93ik-0"
})(["height:100%;color:inherit;align-items:center;border:0;display:flex;padding:0 ", ";border-right:1px solid ", ";", ";> svg{flex:1 0 auto;}* + *{margin-left:", ";}span{max-width:", ";}"], (0, _rem.default)(_constants.CONTAINER_X_PADDING), function (_ref) {
  var _ref$palette = _ref.palette,
      palette = _ref$palette === void 0 ? 'bright' : _ref$palette;
  return (0, _toColorString.default)(_objectSpread({}, _designTokens.color.base.charcoal, {
    alpha: _palette.BORDER_OPACITY[palette]
  }));
}, function (_ref2) {
  var isSingleChild = _ref2.isSingleChild;
  return (0, _styledComponents.css)(["max-width:", ";border-width:", ";"], isSingleChild ? '100%' : "calc(100% - ".concat(_constants.ACTION_WIDTH, "px)"), isSingleChild ? '0' : '1px');
}, (0, _rem.default)(_constants.ICON_CONTENT_MARGIN), getContentMaxWidth);

exports.Content = Content;

var contentSVGColor = function contentSVGColor(_ref3) {
  var variant = _ref3.variant,
      colorProp = _ref3.color;

  if (variant === 'outline' && colorProp && colorProp in _commonUIColors.commonUIColors) {
    return (0, _styledComponents.css)(["", " svg{color:", ";}"], Content, (0, _toColorString.default)(_commonUIColors.commonUIColors[colorProp]));
  }

  return null;
};

var actionColors = {
  normal: (0, _toColorString.default)(interactionColors.indianOcean),
  danger: (0, _toColorString.default)(statusColors.danger.medium)
};

var actionColor = function actionColor(_ref4) {
  var actionIntent = _ref4.actionIntent;
  return actionColors[actionIntent !== 'danger' ? 'normal' : 'danger'];
};

var colorModifiers = function colorModifiers(props) {
  var _props$palette = props.palette,
      palette = _props$palette === void 0 ? 'bright' : _props$palette;

  var borderColor = _objectSpread({}, _designTokens.color.base.charcoal, {
    alpha: _palette.BORDER_OPACITY[palette]
  });

  return (0, _styledComponents.css)(["", " ", " ", ""], (0, _palette.withBorderedPalette)(props), (0, _styleModifiers.when)('variant', 'outline', (0, _styledComponents.css)(["", ""], (0, _color.default)(_objectSpread({}, _designTokens.color.base.snowWhite, {
    fg: _designTokens.color.base.alaskanHusky
  })))), (0, _styleModifiers.when)('isSingleChild', false, (0, _styledComponents.css)(["&:hover{box-shadow:inset 0 0 0 ", " ", ";", "{border-color:transparent;}}"], (0, _rem.default)(100), (0, _toColorString.default)(borderColor), Content)));
};

var variantModifiers = function variantModifiers(props) {
  var _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'normal' : _props$variant;
  if (variant === 'normal') return undefined;
  return (0, _styledComponents.css)(["border:1px solid ", ";", " &:focus{border:1px solid ", ";::before{", ";}}"], (0, _toColorString.default)(_designTokens.color.opacity.charcoal15), (0, _styleModifiers.when)('isSingleChild', false, (0, _styledComponents.css)(["&:hover{background-color:", ";}"], (0, _toColorString.default)(_objectSpread({}, _designTokens.color.base.charcoal, {
    alpha: 0.07
  })))), (0, _toColorString.default)(_designTokens.color.interaction.pacificOcean), (0, _focusRingWithColor.default)(_designTokens.color.interaction.pacificOcean40));
};

var sizeModifiers = function sizeModifiers(props) {
  var _props$size = props.size,
      size = _props$size === void 0 ? 'small' : _props$size;
  if (size === 'small') return undefined;
  var mediumHeight = (0, _rem.default)(25);
  var mediumRadius = (0, _rem.default)(15);
  var mediumBorderRadius = "0 ".concat(mediumRadius, " ").concat(mediumRadius, " 0");
  return (0, _styledComponents.css)(["height:", ";border-radius:", ";&:focus{::before{border-radius:", ";}}", "{padding-right:", ";}", ",", "{border-radius:", ";}"], mediumHeight, mediumRadius, mediumRadius, _Action.default, (0, _rem.default)(2), _Action.default, _Action.ActionContainer, mediumBorderRadius);
};

var Container = _styledComponents.default.div.withConfig({
  displayName: "styles__Container",
  componentId: "sc-1sm93ik-1"
})(["position:relative;font-family:", ";font-size:", ";font-weight:", ";align-items:center;justify-content:center;border-radius:", ";display:inline-flex;height:", ";max-width:100%;min-width:", ";background-color:transparent;padding:0;", " &:focus{border:1px solid ", ";&::before{position:absolute;top:0;left:0;width:100%;height:100%;content:'';border-radius:", ";", ";}}&:focus-visible{outline:none;}&:hover{", "{color:", ";}}", ";", ";", ";", ";"], _designTokens.typography.typeface.default, (0, _rem.default)(_designTokens.typography.size.alias.default), _designTokens.typography.weight.alias.default, (0, _rem.default)(10), (0, _rem.default)(20), (0, _rem.default)(26), (0, _styleModifiers.when)('isSingleChild', false, (0, _styledComponents.css)(["cursor:pointer;"])), (0, _toColorString.default)(_designTokens.color.base.blackSheep), (0, _rem.default)(10), (0, _focusRingWithColor.default)(_designTokens.color.opacity.charcoal40), _Action.default, actionColor, sizeModifiers, colorModifiers, variantModifiers, contentSVGColor);

exports.Container = Container;